<template>
  <div class="new-user-list">
    <b-table small :current-page="currentPage"
      :per-page="perPage" :fields="fields" :items="users" responsive="sm" class="new-user-table">
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(icon)="data">
        <p><img v-bind:src="data.item | avatar"/></p>
      </template>
      <template v-slot:cell(created_at)="data">
        {{ data.value | formatDateTime }}
      </template>
      <template v-slot:cell(last_login_at)="data">
        {{ data.value | formatDateTime }}
      </template>
      <template v-slot:cell(detail)="data">
        <router-link class="detail" :to="{ name: 'user_detail', params: { id: data.item.id }}" exact>詳細</router-link>
      </template>
      <template v-slot:cell(station)="data">
        {{ data.item.parent.station ? data.item.parent.station.name : '' }}
      </template>
    </b-table>
    <b-row class="pagination-bar">
      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import apiClient from '../../backend'

export default {
  methods: {
  },
  data () {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      fields: [
        {key: 'index', sortable: true, class: 'number'},
        {key: 'icon', label: 'Icon', class: 'avatar'},
        {key: 'name', label: '名前', sortable: true},
        {key: 'age', label: '年齢', sortable: true},
        {key: 'email', label: 'ID', sortable: true},
        {key: 'created_at', label: '登録日', sortable: true},
        {key: 'last_login_at', label: '最後のログイン', sortable: true},
        {key: 'login_count', label: 'ログイン回数', sortable: true},
        {key: 'station', label: '最寄駅', sortable: true},
        {key: 'detail', label: '詳細表示'},
      ],
      users: [ ]
    }
  },
  components: {
  },
  mounted () {
    apiClient.getUsers({role: 1, admin_blocked: 1}).then(response => {
      console.log(response)
      this.users = response
      this.totalRows = this.users.length
    })
  },
  methods: {
  },
}
</script>
